
import { createApiMethod } from '../../lib/apiController'


/** method list */
export default {

  changeUserRole:  createApiMethod('/sso/action/change-user-role'),

  // updateClerkUser: createApiMethod('/sso/action/update-store-clerk'),
  changeClerkPassword:  createApiMethod('/sso/action/change-clerk-password'),

  createStoreOwner: createApiMethod('/sso/action/create-store-owner'),

  storeClerks: createApiMethod('/sso/action/get-store-clerks'),
  storeOwners: createApiMethod('/sso/action/get-store-owners'),

  ssoStoreUsers: createApiMethod('/sso/action/get-store-user-list'),
  ssoCheckReviewers: createApiMethod('/sso/action/get-check-reviewer-list'),

  createUser: createApiMethod('/sso/action/create-sso-user'),
  createTechnician: createApiMethod('/sso/action/create-technician'),
  userInfo: createApiMethod('/sso/action/sso-user'),
  changeUserPassword: createApiMethod('/sso/action/change-sso-user-password'),
  getUserPermissions: createApiMethod('/sso/action/get-user-permissions'),
  closeUserSession: createApiMethod('/sso/action/close-user-session'),
}




// WEBPACK FOOTER //
// ./src/templates/sso-redirecting/ssoActions.js